// Formatting helpers used by the dashboard
export const fmt = {
  price(v, currency = "USD") {
    if (v == null || isNaN(v)) return "—";
    const opts = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    if (currency === "TWD") return `NT$${Number(v).toLocaleString("en-US", opts)}`;
    return `$${Number(v).toLocaleString("en-US", opts)}`;
  },
  num(v, digits = 2) {
    if (v == null || isNaN(v)) return "—";
    return Number(v).toLocaleString("en-US", {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    });
  },
  int(v) {
    if (v == null || isNaN(v)) return "—";
    return Number(v).toLocaleString("en-US");
  },
  pct(v, digits = 2) {
    if (v == null || isNaN(v)) return "—";
    const sign = v > 0 ? "+" : "";
    return `${sign}${Number(v).toFixed(digits)}%`;
  },
  bigMoney(v, currency = "USD") {
    if (v == null || isNaN(v)) return "—";
    const symbol = currency === "TWD" ? "NT$" : "$";
    const abs = Math.abs(v);
    if (abs >= 1e12) return `${symbol}${(v / 1e12).toFixed(2)}T`;
    if (abs >= 1e9) return `${symbol}${(v / 1e9).toFixed(2)}B`;
    if (abs >= 1e6) return `${symbol}${(v / 1e6).toFixed(2)}M`;
    return `${symbol}${Number(v).toLocaleString("en-US")}`;
  },
  billion(v, currency = "USD") {
    if (v == null || isNaN(v)) return "—";
    const symbol = currency === "TWD" ? "NT$" : "$";
    return `${symbol}${Number(v).toFixed(1)}B`;
  },
  date(d) {
    try {
      return new Date(d).toLocaleDateString("zh-Hant", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    } catch {
      return d;
    }
  },
};

export function upColor(v) {
  if (v == null || isNaN(v)) return "text-zinc-400";
  return v >= 0 ? "text-emerald-400" : "text-red-400";
}

export function upBgClass(v) {
  if (v == null || isNaN(v)) return "bg-zinc-500/10 border-zinc-500/20 text-zinc-400";
  return v >= 0
    ? "bg-emerald-500/10 border-emerald-500/20 text-emerald-400"
    : "bg-red-500/10 border-red-500/20 text-red-400";
}
